import React from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import { IChildConnectionDTO, IConnectionAttendeeDTO, IConnectionDetailsDTO, IConnectionGroupDTO, IParentConnectionDTO } from '../../../../../../../api/connections.dao';
import IconCircleWithDotsSVG from '../../../../../../../images/svg/circle-with-dots';
import IconCheckedSVG from '../../../../../../../images/svg/icons8-checked';
import { ConnectionEntity } from '../../../../../../../modules/connections/abstract-connection.entity';
import { PresenterOrHostMeetingAttendee } from '../../../../../../../modules/connections/meeting/presenter-or-host-attendee-meeting.connection.entity';

export interface IDropdownConnectionGroupDetails {
    connection: IConnectionDetailsDTO;
    attendeeParentConnection: IParentConnectionDTO;
    attendeeChildConnection: IChildConnectionDTO;
}

export type AttendeeUniqueConnectionGroupIndicatorProps = {
    entity: ConnectionEntity<IConnectionAttendeeDTO> | PresenterOrHostMeetingAttendee;
    assignedConnectionGroup: IConnectionGroupDTO;
    meetingConnections: IConnectionDetailsDTO[];
    parentConnections: IParentConnectionDTO[];
    withLeftMargin: boolean;
    setIsOpenConnectionsInGroup: React.Dispatch<React.SetStateAction<boolean>>;
    isOpenConnectionsInGroup: boolean;
};

export const AttendeeUniqueConnectionGroupIndicator: React.FC<AttendeeUniqueConnectionGroupIndicatorProps> = observer(({
    entity,
    assignedConnectionGroup,
    meetingConnections,
    parentConnections,
    withLeftMargin,
    setIsOpenConnectionsInGroup,
    isOpenConnectionsInGroup,
}): JSX.Element => {
    const groupAutosyncConnections = assignedConnectionGroup.joinMethods
        .reduce((cons, cur) => {
            const autosyncConnection = meetingConnections.find(c => c.autoSyncEnabled && c.joinMethodId === cur.joinMethodId);
            if (autosyncConnection) {
                cons.push(autosyncConnection.meetingConnectionId);
            }
            return cons;
        }, []);

    const getChildAttendeeConnections = () => {
        const assignendGroupChildrenConnections = parentConnections.find(p =>
            p.meetingConnectionId === assignedConnectionGroup.meetingConnectionId
        )?.children || [];

        return assignendGroupChildrenConnections.filter(child => child.attendeeId === entity.getId());
    };
    const childConnections = getChildAttendeeConnections();
    const isChildrenEmpty = !childConnections.length;

    const togglePopover = () => {
        setIsOpenConnectionsInGroup(prev => !prev);
    };

    return (
        <div
            className={cn('attendee-connection__unique-icon', {
                'attendee-connection__unique-icon--margin-left': withLeftMargin,
                'attendee-connection__unique-icon--active': isOpenConnectionsInGroup && !!groupAutosyncConnections.length,
                'attendee-connection__unique-icon--checked': !!groupAutosyncConnections.length || !isChildrenEmpty,
            })}
        >
            {
                !!groupAutosyncConnections.length && isChildrenEmpty
                ? <div
                        className='attendee-connection__unique-icon--wrapper'
                        onClick={togglePopover}
                    >
                        <IconCircleWithDotsSVG />
                    </div>
                : !isChildrenEmpty
                    ? <div
                        className='attendee-connection__unique-icon--wrapper'
                        onClick={togglePopover}
                    >
                        <span className='attendee-connection__children'>{childConnections.length}</span>
                        <span className='flex'><IconCheckedSVG /></span>
                    </div>
                    : null
            }
        </div>
    );
});
